import { Component, OnInit } from '@angular/core';
import { PublisherService } from '../../../core/services/publisher.service';
import { OktaOperation } from '../okta-operation';
import {
  CacheConstant,
  OktaOperationType
} from '../../../core/constants/app.constant';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { BaseComponent } from '../../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { Router } from '@angular/router';
import { AppConfigService } from '../../../core/services/init/app-config.service';

@Component({
  selector: 'par-email-sent',
  templateUrl: './email-sent.component.html',
  styleUrls: ['./email-sent.component.scss']
})
export class EmailSentComponent extends BaseComponent implements OnInit {
  /***************Properties***************/
  websiteName: string =  this.cache.get(CacheConstant.Env_Properties).theme;
  operationMessage: String = '';
  emailAddress: String = '';
  /***************Properties***************/

  /***************Constructor***************/
  constructor(deviceDetectorService: DeviceDetectorService,
  private cache:AppCacheService,
  private appConfig: AppConfigService,
  private router: Router) {
    super(deviceDetectorService, cache, appConfig);
  }

  ngOnInit() {
    const operation = this.cache.get(
      CacheConstant.Okta_Operation
    ) as OktaOperation;
    this.cache.remove(CacheConstant.Okta_Operation);

    if (!operation || !operation.data || !operation.data.emailAddress) {
      AppUtilService.redirectToHome();
      return;
    }

    PublisherService.changeBannerHeader('Email Sent');
    this.emailAddress = operation.data.emailAddress;
    this.operationMessage = this.getOpertaionMessage(operation.type);
  }
  /***************Constructor***************/

  /***************Component Methods***************/

  onCancelClick() {
    // AppUtilService.redirectToHome();
    if (!this.isMobileDevice()) {
      AppUtilService.redirectToHome();
    } else {
      AppUtilService.redirectToHomeMobile();
    }
  }

  onHomeClick() {
    this.router.navigate(['/']);
  }

  /***************Component Methods***************/

  private getOpertaionMessage(operationType: OktaOperationType) {
    let operationMessage = '';

    switch (operationType) {
      case OktaOperationType.ForgotPassword:
        operationMessage = 'resetting your password';
        break;

      case OktaOperationType.UnlockAccount:
        operationMessage = 'unlocking your account';
        break;

      default:
        break;
    }

    return operationMessage;
  }
}
